import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const AddressLine = styled.p`
  text-transform: capitalize;
  margin: 0;
`;
